import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@ibk/shared-ui';
import styles from './QuickActions.module.css';
export const QuickActions = ({ actions, className = '', 'data-testid': dataTestId }) => {
    const enabledActions = actions.filter(action => action.enabled !== false);
    if (enabledActions.length === 0) {
        return null;
    }
    return (_jsx("div", { className: `${styles.container} ${className}`, "data-testid": dataTestId || 'quick-actions', children: _jsx("div", { className: styles.actionsGrid, "data-testid": 'quick-actions-grid', children: enabledActions.map(action => (_jsx(QuickActionItem, { action: action }, action.id))) }) }));
};
const QuickActionItem = ({ action }) => {
    const baseTestId = action['data-testid'] || `quick-action-${action.id}`;
    return (_jsxs("button", { className: styles.actionCard, onClick: action.onClick, "data-testid": baseTestId, type: 'button', children: [_jsx("div", { className: styles.iconContainer, "data-testid": `${baseTestId}-icon-container`, children: _jsx(Icon, { name: action.icon, className: styles.icon }) }), _jsx("span", { className: styles.title, "data-testid": `${baseTestId}-title`, children: action.title })] }));
};
